var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWoman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 498.816 498.816",
    style: {
      enableBackground: "new 0 0 498.816 498.816"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 183.404,
    cy: 238.816,
    rx: 81,
    ry: 80
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 315.412,
    cy: 238.816,
    rx: 81,
    ry: 80
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 249.404,
    cy: 76.72,
    rx: 73,
    ry: 72.08
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 177.492,
    cy: 63.48,
    rx: 27,
    ry: 26.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 201.492,
    cy: 44.816,
    rx: 27,
    ry: 26.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 164.188,
    cy: 91.488,
    rx: 27,
    ry: 26.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 164.188,
    cy: 118.144,
    rx: 27,
    ry: 26.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 160.524,
    cy: 139.728,
    rx: 20.664,
    ry: 20.408
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 153.196,
    cy: 160.408,
    rx: 20.664,
    ry: 20.408
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 215.524,
    cy: 17.448,
    rx: 17.664,
    ry: 17.448
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 237.972,
    cy: 19.488,
    rx: 17.664,
    ry: 17.448
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 321.308,
    cy: 63.48,
    rx: 27,
    ry: 26.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 297.308,
    cy: 44.816,
    rx: 27,
    ry: 26.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 334.636,
    cy: 91.488,
    rx: 27,
    ry: 26.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 334.636,
    cy: 118.144,
    rx: 27,
    ry: 26.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 338.292,
    cy: 139.728,
    rx: 20.664,
    ry: 20.408
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 345.652,
    cy: 160.408,
    rx: 20.664,
    ry: 20.408
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 283.332,
    cy: 17.448,
    rx: 17.664,
    ry: 17.448
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#042635"
    },
    cx: 260.852,
    cy: 19.488,
    rx: 17.664,
    ry: 17.448
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CC9789"
    },
    points: "450.356,366.408 297.412,319.168 297.412,306.608 201.412,306.608 201.412,319.168  48.46,366.408 56.212,498.608 56.212,498.608 57.412,498.608 441.412,498.608 443.532,498.608 443.532,498.608 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BF8377"
    },
    points: "450.356,366.408 297.412,319.168 297.412,306.608 201.412,306.608 201.412,319.168  48.46,366.408 101.532,498.608 56.212,498.608 57.412,498.608 441.412,498.608 443.532,498.608 443.532,498.608 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A06660"
    },
    points: "450.356,366.408 297.412,319.168 297.412,305.656 246.34,301.48 244.772,319.168  253.972,366.408 303.996,498.808 56.212,498.608 57.412,498.608 441.412,498.608 443.532,498.608 443.532,498.608 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M354.076,165.472c0,35.344-51.264,64-104.672,64c-53.376,0-104.656-28.656-104.656-64 s51.28-64,104.656-64C302.812,101.472,354.076,130.128,354.076,165.472z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 201.412,
    y: 218.608,
    style: {
      fill: "#BF8377"
    },
    width: 96,
    height: 112
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BF8377"
    },
    points: "290.188,311.312 249.412,416.152 199.908,335.424 249.412,285.92  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A06660"
    },
    points: "297.412,343.808 297.412,218.608 202.388,218.608 250.62,433.208 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC9789"
    },
    d: "M324.372,134.128c0,72.24-36.624,137.624-74.944,137.624s-74.96-65.376-74.96-137.624 s36.64-84.288,74.96-84.288S324.372,61.888,324.372,134.128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8377"
    },
    d: "M249.428,49.84c38.32,0,74.944,12.048,74.944,84.288s-36.624,137.624-74.944,137.624"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M259.844,45.08c0,0-69.656,53.328,89.92,117.568c0,0,3.064-70.688-23-101.504 c-26.08-30.8-66.44-27-66.44-27L259.844,45.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M284.796,35.968c0,0,64.168,71.112-135.672,132.048c0,0-11.784-75.976,18.984-108.528 c30.76-32.552,85.92-27.144,85.92-27.144L284.796,35.968z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 161.412,
    y: 90.608,
    style: {
      fill: "#042635"
    },
    width: 128,
    height: 72
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#042635"
    },
    points: "337.412,162.608 298.46,162.608 278.956,90.608 337.412,90.608  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1BAFA4"
    },
    d: "M165.684,257.816c14.64,0,26.496-11.864,26.496-26.496c0-4.608-1.28-8.888-3.36-12.664 c-4.496,8.208-13.12,13.832-23.144,13.832"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36CEC6"
    },
    d: "M165.748,232.488c-10.032,0-18.64-5.624-23.144-13.832c-2.08,3.776-3.36,8.056-3.36,12.664 c0,14.632,11.856,26.496,26.496,26.496s26.496-11.864,26.496-26.496c0-4.608-1.28-8.888-3.36-12.664 C184.388,226.864,175.764,232.488,165.748,232.488z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1BAFA4"
    },
    cx: 165.748,
    cy: 211.488,
    r: 4.672
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E5C15C"
    },
    cx: 165.748,
    cy: 265.48,
    r: 4.672
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E5C15C"
    },
    cx: 165.748,
    cy: 274.768,
    r: 4.672
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E5C15C"
    },
    cx: 165.748,
    cy: 284.128,
    r: 4.672
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E5C15C"
    },
    cx: 165.748,
    cy: 293.488,
    r: 4.672
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36CEC6"
    },
    d: "M333.076,232.488c-10.016,0-18.64-5.624-23.144-13.832c-2.08,3.776-3.36,8.056-3.36,12.664 c0,14.632,11.856,26.496,26.496,26.496s26.496-11.864,26.496-26.496c0-4.608-1.28-8.888-3.36-12.664 C351.716,226.864,343.108,232.488,333.076,232.488z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1BAFA4"
    },
    cx: 333.092,
    cy: 211.488,
    r: 4.672
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E5C15C"
    },
    cx: 333.092,
    cy: 265.48,
    r: 4.672
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E5C15C"
    },
    cx: 333.092,
    cy: 274.768,
    r: 4.672
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E5C15C"
    },
    cx: 333.092,
    cy: 284.128,
    r: 4.672
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E5C15C"
    },
    cx: 333.092,
    cy: 293.488,
    r: 4.672
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6C425"
    },
    d: "M387.828,498.608c-20.88-80-56.76-34-138.416-34s-117.536-46-138.416,34H387.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFAA13"
    },
    d: "M113.412,498.608h274.416c-20.872-80-55.552-34-137.208-34"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6C425"
    },
    d: "M129.412,494.016c0,2.656-1.512,4.8-4,4.8l0,0c-2.488,0-4-2.144-4-4.8V341.608 c0-2.64,1.512-4.8,4-4.8l0,0c2.488,0,4,2.16,4,4.8V494.016z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFAA13"
    },
    d: "M377.412,494.016c0,2.656-1.512,4.8-4,4.8l0,0c-2.488,0-4-2.144-4-4.8V341.608 c0-2.64,1.512-4.8,4-4.8l0,0c2.488,0,4,2.16,4,4.8V494.016z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36CEC6"
    },
    d: "M249.412,388.808c-41.28,0-75.272-33.216-79.912-76c-0.352,3.28-0.584,6.608-0.584,10 c0,47.504,36.048,86,80.496,86c44.464,0,80.496-38.496,80.496-86c0-3.392-0.232-6.72-0.584-10 C324.668,355.592,290.692,388.808,249.412,388.808z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.821,
    y: 375.771,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 708.1037 505.3563)",
    style: {
      fill: "#D6C425"
    },
    width: 47.136,
    height: 47.12
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BFAA13"
    },
    points: "282.732,399.312 249.404,432.64 250.188,399.312 249.404,365.984 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoman);
export default __webpack_public_path__ + "static/media/woman.77048788e1d7c7fb50da74320c4c5c90.svg";
export { ForwardRef as ReactComponent };